import React, { Component } from 'react';
import { Route, BrowserRouter as Router } from 'react-router-dom';

import Main from './components/main/main';
import Callback from './components/callback/callback';

// import 'bootstrap/dist/css/bootstrap.css'; 
import './App.css';

class App extends Component {
  /**
   * Renders the component.
   */
  render() {
    return (
      <Router basename={"/graphiql"}>
        <div className="App">
          <Route path="/" exact component={Main} />

          <Route path="/callback.html" component={Callback} />
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js